/* Velvety scroll-to-top button.
 *
 * Shows the floating button after the user scrolls past 400px, hides
 * it again at the top. Click → jump back to y=0 (no smooth scroll).
 *
 * Uses requestAnimationFrame to throttle scroll events. The button is
 * hidden by default (hidden attribute) and gains is-visible when in
 * view; removing the attribute on first show lets the fade-in
 * transition run.
 */
(function () {
  var SHOW_AFTER = 400;
  var btn = document.querySelector('[data-velvety-scroll-top]');
  if (!btn) return;

  /* On the product page a full-width sticky Add-to-Bag bar is fixed to the
     bottom of the viewport. Lift the scroll-top button above it (by the bar's
     measured height + a small gap) so the two don't overlap. On other pages,
     or when the bar isn't shown, fall back to the CSS default offset. */
  var stickyBar = document.querySelector('.velvety-product__sticky-atc');
  var waBtn = document.querySelector('.velvety-whatsapp');
  function positionAboveBar() {
    if (stickyBar && stickyBar.classList.contains('is-visible')) {
      var base = stickyBar.offsetHeight + 16;
      btn.style.bottom = base + 'px';
      /* Lift the WhatsApp button to stack ABOVE the raised scroll-top, otherwise
         the two collide once the scroll-top jumps up to clear the sticky bar. */
      if (waBtn) {
        var stH = btn.offsetHeight || (window.innerWidth <= 749 ? 40 : 44);
        waBtn.style.bottom = (base + stH + 16) + 'px';
      }
    } else {
      btn.style.bottom = '';
      if (waBtn) waBtn.style.bottom = '';
    }
  }

  var ticking = false;
  function update() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (y > SHOW_AFTER) {
      if (btn.hasAttribute('hidden')) btn.removeAttribute('hidden');
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
    positionAboveBar();
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', positionAboveBar, { passive: true });
  positionAboveBar();

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'auto' });
  });
})();
